__turbopack_context__.v({
  "arrow": "ld9qFW_arrow",
  "card": "ld9qFW_card",
  "description": "ld9qFW_description",
  "icon": "ld9qFW_icon",
  "link": "ld9qFW_link",
  "skeletonBlock": "ld9qFW_skeletonBlock",
  "text": "ld9qFW_text",
  "title": "ld9qFW_title",
});
